import axios, { useZionAxios } from '@fs/zion-axios'

/**
 * Get list of gedcom files
 * @returns {object} The information about all uploaded files.
 */

export default async function getGedcomFileList() {
  return axios.get(`/service/tree/gedcom/upload/files`).then((res) => res.data)
}
export const useGedcomFileList = () => {
  return useZionAxios(`/service/tree/gedcom/upload/files`, { manual: true })
}
